import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { RephraseOptionsService } from './service/rephrase-options.service';

@Component({
  selector: 'app-rephrase-options',
  imports: [
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    TranslateModule,
  ],
  templateUrl: './rephrase-options.component.html',
  styleUrl: './rephrase-options.component.scss',
})
export class RephraseOptionsComponent {
  readonly rephraseOptions = inject(RephraseOptionsService);
}
